module.exports = __webpack_public_path__ + "img/banner.f39221a2.jpg";